import React from 'react';

import ResourceDropdown from '../ResourceDropdown';

interface ResourceListSortProps {
  onSortSelect: (x: number) => void;
  sorts: string[];
  activeSortIndex: number;
}
export const ResourceListSort: React.FC<ResourceListSortProps> = ({
  onSortSelect,
  sorts,
  activeSortIndex,
}: ResourceListSortProps) => (
  <div data-testid="resourceSort">
    <ResourceDropdown
      items={sorts}
      onItemSelect={onSortSelect}
      activeIndex={activeSortIndex}
      id="dropdownResourceSort"
      label="Sort"
      name="dropdownResourceSort"
    />
  </div>
);

export default ResourceListSort;
